import React from 'react';
import styled from 'styled-components';
import ThumbnailSlider from '../slide/ThumbnailSlider';
import { useState } from 'react';
import { useEffect } from 'react';
import {isMobileOnly} from 'react-device-detect';

const ProdThumbnailBlock = styled.div`
    position: relative;
/*JP responsive*/    
    ${!isMobileOnly && `
      float: left;
      // width: 52.1%;
      width: 585px;
      margin-right: 53px;          
    `};    
/*JP responsive*/    
    overflow: hidden;
    .thumbnail-slider-container {
/*JP responsive*/    
        ${isMobileOnly?`margin-bottom:2rem;`: `
            float: left;
            // width: 15%;
            width: 75px;
            margin-right: 10px;             
        `};
/*JP responsive*/        
        .thumbnail-slider-block {         
/*JP responsive*/          
          ${!isMobileOnly && `
            width: 75px;
            height: 500px;
            margin-right: 10px;              
          `};
/*JP responsive*/          
        }
    }    
    .pd-img-container {
/*JP responsive*/    
        ${!isMobileOnly && `
          float: right;
          // width: 85%;
          width: 500px;
          height: 500px;        
        `};
/*JP responsive*/        
        border-radius: 10px;
        overflow: hidden;    
      img {
        width: 100%;
      }
    }
`;

const ProdThumbnail = (prop) => {

    const [curImg, setCurImg] = useState(prop.imglist[0]);

    useEffect(() => {
        setCurImg(prop.imglist[0]);
    }, [prop])

    const handleMouseOver = (imginfo) => {
        // console.log("imginfo > " + imginfo);
        setCurImg(imginfo);
    }

    return (
        <ProdThumbnailBlock>
            <div className="thumbnail-slider-container">
                <div className="thumbnail-slider-block">
                    <ThumbnailSlider imglist={prop.imglist} display_num={isMobileOnly?4:6} mouseover={handleMouseOver} />
                </div>
            </div>
            <div className="pd-img-container">
                <img src={curImg === undefined ? prop.imglist[0] : curImg} alt="" />
            </div>

        </ProdThumbnailBlock>
    );
};

export default ProdThumbnail;
